// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"3dd3b8b4","165":"ae80d493","245":"1440b033","275":"93cfc4aa","398":"17f62000","407":"85f826c9","453":"1a33e5cf","572":"08771a7c","736":"954b1cc6","874":"8cb34e8e","964":"7da68b28","990":"4c1367a7"}[chunkId] + ".chunk.js";
};